import { Navigate, type RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import AppShell from '../components/feature/AppShell';
import RequireAuth from '../components/feature/RequireAuth';
import Login from '../pages/login/page';
import ChangePassword from '../pages/change-password/page';
import Dashboard from '../pages/dashboard/page';
import Campaigns from '../pages/campaigns/page';
import NewCampaign from '../pages/campaigns/new/page';
import CampaignDetail from '../pages/campaigns/detail/page';
import Discovery from '../pages/discovery/page';
import CreatorDetail from '../pages/creators/detail/page';
import Invoices from '../pages/invoices/page';
import InvoiceDetail from '../pages/invoices/detail/page';
import BulkPayments from '../pages/payments/bulk/page';
import SendPayment from '../pages/payments/send/page';
import Transactions from '../pages/payments/transactions/page';
import Payouts from '../pages/payouts/page';
import Reports from '../pages/reports/page';
import Wallets from '../pages/payments/wallets/page';
import Roles from '../pages/settings/roles/page';
import Users from '../pages/settings/users/page';
import Branding from '../pages/settings/branding/page';
import AuditLog from '../pages/settings/audit/page';
import Outbox from '../pages/dev/outbox/page';
import ForgotPassword from '../pages/forgot-password/page';
import ResetPassword from '../pages/reset-password/page';
import JoinAgency from '../pages/join/page';

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password/:token',
    element: <ResetPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  // Public: an agency's join page for creators (no dashboard sign-in).
  {
    path: '/join/:ref',
    element: <JoinAgency />,
  },
  {
    path: '/change-password',
    element: (
      <RequireAuth>
        <ChangePassword />
      </RequireAuth>
    ),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'campaigns', element: <Campaigns /> },
      { path: 'campaigns/new', element: <NewCampaign /> },
      { path: 'campaigns/:id', element: <CampaignDetail /> },
      { path: 'discovery', element: <Discovery /> },
      { path: 'creators/:id', element: <CreatorDetail /> },
      { path: 'invoices', element: <Invoices /> },
      { path: 'invoices/:id', element: <InvoiceDetail /> },
      { path: 'payments/bulk', element: <BulkPayments /> },
      { path: 'payments/send', element: <SendPayment /> },
      { path: 'payments/transactions', element: <Transactions /> },
      { path: 'payouts', element: <Payouts /> },
      { path: 'reports', element: <Reports /> },
      { path: 'payments/wallets', element: <Wallets /> },
      { path: 'settings/roles', element: <Roles /> },
      { path: 'settings/users', element: <Users /> },
      { path: 'settings/branding', element: <Branding /> },
      {
        path: 'settings/audit',
        element: <AuditLog />,
      },
      // Developer/trainer tool for notifications saved in log mode; not in the sidebar.
      { path: 'dev/outbox', element: <Outbox /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;